<template>
  <div class="main diaoduindex">
    <Row :gutter="15" style="margin-bottom:15px">
      <Col span="8">
      <block1></block1>
      </Col>
      <Col span="8">
      <block1></block1>
      </Col>
      <Col span="8">
      <block1></block1>
      </Col>
    </Row>
<Row :gutter="15">
      <Col span="8">
      <block1></block1>
      </Col>
      <Col span="8">
      <block1></block1>
      </Col>
      <Col span="8">
      <block1></block1>
      </Col>
    </Row>
  </div>
</template>

<script>
import block1 from "./block1";
export default {
  components: { block1 },
  data() {
    return {

    };
  },
  methods: {

  },
  mounted() {

  },
};
</script>
<style>
.diaoduindex{
  background: #f5f5f5;
  padding: 15px;
}
</style>


// WEBPACK FOOTER //
// src/components/wuliu/diaodukanban/index.vue